<template>
  <div class="printspace" @mousemove="moveCursor">
    <div class="SlidingWindow">
      <div
        class="SlidingWindow__Left noprint"
        :style="{ width: `${100 * bar}%` }"
      >
        <div class="PrintOptions__panel"><slot name="panel"></slot></div>
      </div>
      <div
        class="SlidingWindow__bar noprint"
        :style="{ left: `calc(${100 * bar}% - 16px)` }"
        draggable="true"
        @mousedown="drag = true"
        @mouseup="drag = false"
      >
        <div class="SlidingWindow__bar__inside noprint"></div>
      </div>
      <div
        class="SlidingWindow__Right"
        :style="{ width: `${100 - 100 * bar}%` }"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { DRAWING_SPACE_MOVED } from "../../../../util/func";

export default {
  name: "SlidingWindow",
  data() {
    return {
      p: {},
      loading: false,
      bar: 0.3,
      drag: false
    };
  },
  methods: {
    moveCursor(e) {
      if (!this.drag) return;
      const w = window.innerWidth;
      this.bar = e.pageX / w;
      this.$root.$emit(DRAWING_SPACE_MOVED);
    }
  }
};
</script>

<style lang="scss">
.printspace {
  width: 100vw;
  height: 100vh;
  max-width: none !important;
  padding-bottom: 0 !important;
}

.SlidingWindow {
  height: 100%;
  width: 100%;

  &__Left {
    box-shadow: -3px 0 10px 5px rgba(255, 255, 255, 0.5);
    z-index: 1;
    padding: 16px;
    overflow: hidden;
    @media print {
      display: none;
    }
  }

  &__Left,
  &__Right {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }

  &__bar {
    position: absolute;
    z-index: 3;
    cursor: ew-resize;
    height: 100%;
    top: 0;
    padding: 0 15px;
    &__inside {
      background: black;
      width: 1px;
      height: 100%;
    }
  }

  &__Right {
    right: 0;
    left: auto;
    z-index: 0;
    @media print {
      width: 100% !important;
    }
  }
}

.PrintOptions__panel {
  height: 100%;
  z-index: 1;
  overflow-y: scroll;
  padding-right: 32px;
  width: calc(100% + 32px);
}
</style>
